import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { OpenModalConfirmService } from './../../services/open-modal-confirm.service';
import { FormResponseService } from './../../services/form-response-service';

@Component({
  selector: 'app-qr-code-public-panel',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="pdf-viewer-wrapper" *ngIf="pdfUrl; else loadingTemplate">
      <iframe
        class="pdf-viewer"
        [src]="pdfUrl"
        title="Visualizador de PDF">
      </iframe>
    </div>

    <ng-template #loadingTemplate>
      <div class="pdf-loading">
        Carregando PDF...
      </div>
    </ng-template>
  `,
  styles: [`
    .pdf-viewer-wrapper {
      width: 100%;
      height: 100vh;
      overflow: hidden;
      background: #f5f5f5;
    }

    .pdf-viewer {
      width: 100%;
      height: 100%;
      border: none;
      display: block;
    }

    .pdf-loading {
      width: 100%;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
    }
  `]
})
export class QrCodePublicPanelComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private formResponseService = inject(FormResponseService);
  private openModalConfirmService = inject(OpenModalConfirmService);
  private translate = inject(TranslateService);
  private sanitizer = inject(DomSanitizer);

  private responseId = '';
  private filePath = '';
  private blobUrls: string[] = [];
  private openedInSameTab = false;

  pdfUrl: SafeResourceUrl | null = null;

  ngOnInit() {
    this.responseId = this.activatedRoute.snapshot.paramMap.get('responseId') || '';

    this.filePath =
      this.activatedRoute.snapshot.queryParamMap.get('filePath') ||
      this.activatedRoute.snapshot.paramMap.get('filePath') ||
      '';

    if (!this.responseId || !this.filePath) {
      this.showError();
      return;
    }

    const certLink = window.location.href;

    this.formResponseService
      .getSignedReportPublic(this.responseId, this.filePath, certLink)
      .subscribe({
        next: (blob: Blob) => {
          const pdfBlob = new Blob([blob], { type: 'application/pdf' });
          const url = URL.createObjectURL(pdfBlob);

          this.blobUrls.push(url);

          if (this.isMobileDevice()) {
            this.openedInSameTab = true;
            window.location.href = url;
            return;
          }

          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        },
        error: () => this.showError()
      });
  }

  private isMobileDevice(): boolean {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent);
  }

  private showError() {
    this.openModalConfirmService.openModalConfirm({
      type: 'error',
      text: this.translate.instant('CHECKLISTS.RESPONSE-FORM.QRCODE-ERROR-TEXT'),
      subText: this.translate.instant('PRODUCTS.LOAD-DATA-SUBTEXT'),
      confirmText: 'Ok',
      hideCancelButton: true
    }).subscribe(() => {
      this.router.navigate(['/']);
    });
  }

  ngOnDestroy() {
    if (this.openedInSameTab) {
      return;
    }

    this.blobUrls.forEach(url => {
      try {
        URL.revokeObjectURL(url);
      } catch {}
    });

    this.blobUrls = [];
    this.pdfUrl = null;
  }
}